import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import commonEn from "./locales/en/common.json";
import navEn from "./locales/en/nav.json";
import authEn from "./locales/en/auth.json";
import workspacesEn from "./locales/en/workspaces.json";
import accountSettingsEn from "./locales/en/accountSettings.json";
import aiToolsEn from "./locales/en/aiTools.json";
import auditTrailsEn from "./locales/en/auditTrails.json";
import balancedScorecardEn from "./locales/en/balancedScorecard.json";
import dashboardEn from "./locales/en/dashboard.json";
import dashboardModalsEn from "./locales/en/dashboardModals.json";
import dataAnonymisationEn from "./locales/en/dataAnonymisation.json";
import dataCleaningEn from "./locales/en/dataCleaning.json";
import docProcessingEn from "./locales/en/docProcessing.json";
import docProcessingCodesEn from "./locales/en/docProcessingCodes.json";
import docProcessingDescriptorsEn from "./locales/en/docProcessingDescriptors.json";
import formulaBuilderEn from "./locales/en/formulaBuilder.json";
import googleDriveEn from "./locales/en/googleDrive.json";
import helpCenterEn from "./locales/en/helpCenter.json";
import libraryEn from "./locales/en/library.json";
import projectHubEn from "./locales/en/projectHub.json";
import projectsEn from "./locales/en/projects.json";
import reportingEn from "./locales/en/reporting.json";
import subscriptionEn from "./locales/en/subscription.json";
import userManagementEn from "./locales/en/userManagement.json";

import commonAr from "./locales/ar/common.json";
import navAr from "./locales/ar/nav.json";
import authAr from "./locales/ar/auth.json";
import workspacesAr from "./locales/ar/workspaces.json";
import accountSettingsAr from "./locales/ar/accountSettings.json";
import aiToolsAr from "./locales/ar/aiTools.json";
import auditTrailsAr from "./locales/ar/auditTrails.json";
import balancedScorecardAr from "./locales/ar/balancedScorecard.json";
import dashboardAr from "./locales/ar/dashboard.json";
import dashboardModalsAr from "./locales/ar/dashboardModals.json";
import dataAnonymisationAr from "./locales/ar/dataAnonymisation.json";
import dataCleaningAr from "./locales/ar/dataCleaning.json";
import docProcessingAr from "./locales/ar/docProcessing.json";
import docProcessingCodesAr from "./locales/ar/docProcessingCodes.json";
import docProcessingDescriptorsAr from "./locales/ar/docProcessingDescriptors.json";
import formulaBuilderAr from "./locales/ar/formulaBuilder.json";
import googleDriveAr from "./locales/ar/googleDrive.json";
import helpCenterAr from "./locales/ar/helpCenter.json";
import libraryAr from "./locales/ar/library.json";
import projectHubAr from "./locales/ar/projectHub.json";
import projectsAr from "./locales/ar/projects.json";
import reportingAr from "./locales/ar/reporting.json";
import subscriptionAr from "./locales/ar/subscription.json";
import userManagementAr from "./locales/ar/userManagement.json";

export const SUPPORTED_LANGUAGES = ["en", "ar"] as const;
export const RTL_LANGUAGES = ["ar"];

const applyDirection = (lng: string) => {
  const base = lng.split("-")[0];
  document.documentElement.dir = RTL_LANGUAGES.includes(base) ? "rtl" : "ltr";
  document.documentElement.lang = base;
};

const NAMESPACES = [
  "common",
  "nav",
  "auth",
  "workspaces",
  "accountSettings",
  "aiTools",
  "auditTrails",
  "balancedScorecard",
  "dashboard",
  "dashboardModals",
  "dataAnonymisation",
  "dataCleaning",
  "docProcessing",
  "docProcessingCodes",
  "docProcessingDescriptors",
  "formulaBuilder",
  "googleDrive",
  "helpCenter",
  "library",
  "projectHub",
  "projects",
  "reporting",
  "subscription",
  "userManagement",
];

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        common: commonEn,
        nav: navEn,
        auth: authEn,
        workspaces: workspacesEn,
        accountSettings: accountSettingsEn,
        aiTools: aiToolsEn,
        auditTrails: auditTrailsEn,
        balancedScorecard: balancedScorecardEn,
        dashboard: dashboardEn,
        dashboardModals: dashboardModalsEn,
        dataAnonymisation: dataAnonymisationEn,
        dataCleaning: dataCleaningEn,
        docProcessing: docProcessingEn,
        docProcessingCodes: docProcessingCodesEn,
        docProcessingDescriptors: docProcessingDescriptorsEn,
        formulaBuilder: formulaBuilderEn,
        googleDrive: googleDriveEn,
        helpCenter: helpCenterEn,
        library: libraryEn,
        projectHub: projectHubEn,
        projects: projectsEn,
        reporting: reportingEn,
        subscription: subscriptionEn,
        userManagement: userManagementEn,
      },
      ar: {
        common: commonAr,
        nav: navAr,
        auth: authAr,
        workspaces: workspacesAr,
        accountSettings: accountSettingsAr,
        aiTools: aiToolsAr,
        auditTrails: auditTrailsAr,
        balancedScorecard: balancedScorecardAr,
        dashboard: dashboardAr,
        dashboardModals: dashboardModalsAr,
        dataAnonymisation: dataAnonymisationAr,
        dataCleaning: dataCleaningAr,
        docProcessing: docProcessingAr,
        docProcessingCodes: docProcessingCodesAr,
        docProcessingDescriptors: docProcessingDescriptorsAr,
        formulaBuilder: formulaBuilderAr,
        googleDrive: googleDriveAr,
        helpCenter: helpCenterAr,
        library: libraryAr,
        projectHub: projectHubAr,
        projects: projectsAr,
        reporting: reportingAr,
        subscription: subscriptionAr,
        userManagement: userManagementAr,
      },
    },
    fallbackLng: "en",
    supportedLngs: SUPPORTED_LANGUAGES as unknown as string[],
    ns: NAMESPACES,
    defaultNS: "common",
    interpolation: { escapeValue: false },
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
    },
  });

applyDirection(i18n.language);
i18n.on("languageChanged", applyDirection);

export default i18n;
